module.exports = "/images/shield.png?4c8e775b58a216ee955b77e91922b7aa";